/** https://github.com/Microsoft/TypeScript/issues/29729 */

export var TARGET_CLS = 'moly-wave-target';